<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    笋岗站<br>
站点介绍<br>
笋岗站位于梅园路和宝岗路交叉，北侧旧货市场，南侧深圳市地质局，东侧笋岗村，东北侧笋岗大厦，西侧大兴汽车服务中心。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:26	23:06	7号线	3分35秒	5分55秒<br>
太安	06:23	23:50	7号线	3分35秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:25	23:06	7号线	4分钟	5分55秒<br>
太安	06:21	23:50	7号线	4分钟	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:26	00:06	7号线	4分钟	5分55秒<br>
太安	06:21	00:50	7号线	4分钟	5分55秒<br><br>

站点出口信息<br><br>
A出入口:<br>
梅园路南侧、宝安北路、深业物流大厦、华海达国际服装交易中心、深圳市地质局,罗湖人才市场<br><br>
C1出入口:<br>
宝岗路西、广深铁路有限公司深北地区单身宿舍、新时速嘉园、桃花园住宅、金丽花园、铁东小区、五金花园、梅园路南侧<br><br>
C2出入口:<br>
宝岗路东、田心村、笋岗小学、宝岗花园、元勋旧址、深圳市罗湖医院集团笋岗街道社区健康服务中心、笋岗社区休闲公园、笋岗村、梅园路东侧（北）<br><br>
D出入口:<br>
梅园路东侧（北）、深圳市罗湖区笋岗街道办事处、笋岗街道工作委员会<br><br>
E出入口:<br>
梅园路西侧（北）、深圳人才大市场、深业泰富广场、家之福家居、宝能环球汇购物中心<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 笋岗街道办<br>
18路.63路.69路.303路.322路.323路.333路.366路.371路.381路.n10路<br><br>
C1出入口:<br>
公交站名： 宝岗路<br>
303路.69路<br><br>
C2出入口:<br>
公交站名： 笋岗村牌坊<br>
18路.57路.m482路.322路.m132路.<br><br>
E出入口:<br>
公交站名： 笋岗街道办<br>
18路.63路.69路.303路.322路.323路.333路.366路.371路.381路.n10路<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "qihaoxian",
          title: "7号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>